module.exports = __webpack_public_path__ + "img/exhibits-banner.d9a810a3.jpg";